import { SelectedTalent, User } from '../shared/types';
import { AppContainer } from '@/components/AppContainer';
import { Button } from '@/components/ui/button';
import { Overline } from '@/components/typography';

type Step = 'list' | 'form' | 'confirmation';

interface BookingNavigationProps {
    bookingStep: string,
    navigateToStep: (step: Step) => void,
    showMobileSummary: boolean,
    setShowMobileSummary: (show: boolean) => void,
    selectedTalent: SelectedTalent,
    booker?: User,
    hasPlatforms?: boolean,
    formSubmitDisabled: boolean,
}

function BookingNavigation(props: BookingNavigationProps) {
    const { bookingStep, navigateToStep, showMobileSummary, setShowMobileSummary, selectedTalent, booker, hasPlatforms = true, formSubmitDisabled } = props;
    const stepCount = 2;
    const currentStep = bookingStep === 'list' ? 1 : 2;
    const cannotContinue = !booker || Object.keys(selectedTalent).length < 1 || !hasPlatforms;

    return (
        <div className="fixed inset-x-0 bottom-0 z-20 h-20 border-t border-border bg-white p-2">
            {/* Centered within constrained width so steps align with page content */}
            <AppContainer className="flex items-center justify-center">
                <Overline className="mb-2 hidden lg:block">Step {currentStep} of {stepCount}</Overline>
                <Button
                    type="button"
                    variant="link"
                    size="xs"
                    className="mb-1 text-destructive lg:hidden text-sm"
                    onClick={() => setShowMobileSummary(!showMobileSummary)}
                >
                    {showMobileSummary ? 'Hide' : 'View'} Summary
                </Button>
            </AppContainer>

            {/* Centered within constrained width so CTAs align with page content */}
            <AppContainer className="flex items-center justify-center gap-4">
                {bookingStep === 'form' ? (
                    <Button type="button" variant="secondary" onClick={() => navigateToStep('list')}>
                        &laquo; Back
                    </Button>
                ) : null}

                {bookingStep === 'list' ? (
                    <Button
                        type="button"
                        onClick={() => navigateToStep('form')}
                        disabled={cannotContinue}
                    >
                        Next
                    </Button>
                ) : null}

                {bookingStep === 'form' ? (
                    <Button type="submit" disabled={formSubmitDisabled || cannotContinue}>
                        Submit Brief
                    </Button>
                ) : null}
            </AppContainer>

        </div>
    );
}

export default BookingNavigation;
